/** Client-side mirrors of the server's signup rules. The server still decides. */

export interface PasswordRule {
  id: string
  label: string
  test: (value: string) => boolean
}

export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'length', label: 'At least 8 characters', test: (value) => value.length >= 8 },
  { id: 'upper', label: 'One uppercase letter', test: (value) => /[A-Z]/.test(value) },
  { id: 'number', label: 'One number', test: (value) => /\d/.test(value) },
]

export const passwordIsValid = (value: string): boolean =>
  PASSWORD_RULES.every((rule) => rule.test(value))

export function validateUsername(value: string): string | null {
  const trimmed = value.trim()
  if (trimmed.length < 3) return 'Pick a username with at least 3 characters.'
  if (trimmed.length > 32) return 'Usernames are limited to 32 characters.'
  if (!/^[\w.-]+$/.test(trimmed)) {
    return 'Use letters, numbers, dots, dashes or underscores only.'
  }
  return null
}

export function validateEmail(value: string): string | null {
  if (!value.trim()) return null
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()) ? null : 'That does not look like an email.'
}
